// extracted by mini-css-extract-plugin
export default {"Loading":"styles_Loading__O4DyO","loader":"styles_loader__mtQuq","Overlay":"styles_Overlay__-ma-0"};